export default "__VITE_ASSET__CaaIv8SN__"